import { useContext } from 'react';

import { StateContext } from 'state/state-context';
import { Input, Button, Form } from 'components/Form';
import { Container } from 'components/Container/Container';
import { TextHeader } from 'components/Typography/TextHeader';
import { useFormRedirect } from 'hooks/useFormRedirect';

export const MobileNumber = () => {
  const { form, content } = useContext(StateContext);
  const hasRequiredFields = useFormRedirect(form, ['accountNumber', 'sortCode']);

  if (!hasRequiredFields) {
    return null;
  }
  return (
    <Container>
      <TextHeader>{content('mobile_number_header')}</TextHeader>
      <p>{content('mobile_number_subHeader')}</p>
      <Form>
        <Input name="mobileNumber" inputMode="tel" />
        <p>{content('mobile_number_subHeader_2')}</p>
        <Button
          label="Submit"
          linkTo={`/confirmation`}
          isValid={() => form.fieldsAreValid(['mobileNumber'])}
          icon="right"
        />
      </Form>
    </Container>
  );
};
